import { Channel } from '../types/channel';
import { SelectOption } from '../types/option';

const CHANNEL_NAME_KEYWORD: Record<Channel, string> = {
  loja_fisica: 'fisic',
  loja_online: 'online',
};

const ACCENTED_VOWELS: Record<string, string> = {
  á: 'a',
  à: 'a',
  â: 'a',
  ã: 'a',
  é: 'e',
  ê: 'e',
  í: 'i',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ú: 'u',
};

function normalize(value: string): string {
  return value
    .toLowerCase()
    .split('')
    .map((character) => ACCENTED_VOWELS[character] ?? character)
    .join('');
}

/**
 * Casa o canal escolhido nos cards fixos da UI com a opção correspondente retornada por
 * `/store-types`. O `id` vem do BFF/Movidesk (não é estável para hardcodar), mas o label
 * ("Física"/"Online") é definido pelo próprio time via cadastro do campo customizado no
 * Movidesk — não é texto arbitrário de terceiro sujeito a mudar sem aviso.
 */
export function resolveStoreTypeOptionId(
  options: SelectOption[],
  channel: Channel,
): string | undefined {
  const keyword = CHANNEL_NAME_KEYWORD[channel];
  return options.find((option) => normalize(option.label).includes(keyword))?.id;
}
